import { render } from "./CreateNewCompany.vue?vue&type=template&id=15be38cd&scoped=true"
import script from "./CreateNewCompany.vue?vue&type=script&lang=js"
export * from "./CreateNewCompany.vue?vue&type=script&lang=js"

import "./CreateNewCompany.vue?vue&type=style&index=0&id=15be38cd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15be38cd"]])

export default __exports__